var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.293893 10.7287C0.097964 10.5478 0 10.3176 0 10.0381C0 9.75859 0.097964 9.5284 0.293893 9.34753L4.46183 5.5L0.293893 1.65247C0.097964 1.4716 0 1.2414 0 0.961883C0 0.682362 0.097964 0.452167 0.293893 0.2713C0.489821 0.0904331 0.739185 0 1.04198 0C1.34478 0 1.59415 0.0904331 1.79008 0.2713L6.70611 4.80942C6.81298 4.90807 6.88885 5.01495 6.93374 5.13004C6.97791 5.24514 7 5.36846 7 5.5C7 5.63154 6.97791 5.75486 6.93374 5.86995C6.88885 5.98505 6.81298 6.09193 6.70611 6.19058L1.79008 10.7287C1.59415 10.9096 1.34478 11 1.04198 11C0.739185 11 0.489821 10.9096 0.293893 10.7287Z",
    fill: "#056D62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.48fdc9abc82a1243c2b0572f4b134642.svg";
export { ForwardRef as ReactComponent };